import { render, staticRenderFns } from "./TableUsedItem.vue?vue&type=template&id=0228e4ec"
import script from "./TableUsedItem.vue?vue&type=script&lang=js"
export * from "./TableUsedItem.vue?vue&type=script&lang=js"
import style0 from "./TableUsedItem.vue?vue&type=style&index=0&id=0228e4ec&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports